module.exports = __webpack_public_path__ + "static/assoalho-pelvico-d70a1ef74070131110cc07a0c50779b3.png";